import _objectWithoutProperties from "/home/runner/work/octicons/octicons/docs/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["sx", "active", "as"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import Link from '../Link';
import { merge } from '../sx';
import { Item } from './Item'; // adopted from React.AnchorHTMLAttributes

export var LinkItem = /*#__PURE__*/React.forwardRef(function (_ref, forwardedRef) {
  var _ref$sx = _ref.sx,
      sx = _ref$sx === void 0 ? {} : _ref$sx,
      active = _ref.active,
      Component = _ref.as,
      props = _objectWithoutProperties(_ref, _excluded);

  var styles = {
    // occupy full size of Item
    paddingX: 2,
    paddingY: '6px',
    // custom value off the scale
    display: 'flex',
    flexGrow: 1,
    // full width
    borderRadius: 2,
    // inherit Item styles
    color: 'inherit',
    '&:hover': {
      color: 'inherit',
      textDecoration: 'none'
    }
  };
  return /*#__PURE__*/React.createElement(Item, {
    active: active,
    sx: {
      paddingY: 0,
      paddingX: 0
    },
    _PrivateItemWrapper: function _PrivateItemWrapper(_ref2) {
      var children = _ref2.children;
      return /*#__PURE__*/React.createElement(Link, _extends({
        as: Component,
        sx: merge(styles, sx)
      }, props, {
        ref: forwardedRef
      }), children);
    }
  }, props.children);
});